import React from "react";
import {
  Box,
  theme,
  Stack,
  Avatar,
  Heading,
  IconButton,
} from "@aksara-ui/react";
import { IconFlowerGrid, IconDragHorizontal } from "@aksara-ui/icons";

import { setDrawerMobile } from "redux/actions";
import { useMediaQuery } from "react-responsive";
import AvatarMenu from "./components/AvatarMenu";
import { useDispatch } from "react-redux";

interface Props {
  paddigLeft?: any;
}

const Navbar: React.FC<Props> = ({ paddigLeft }) => {
  const dispatch = useDispatch();
  const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });

  const openDrawer = () => {
    dispatch(setDrawerMobile(true));
  };

  return (
    <Box
      width={"100%"}
      height={"100%"}
      maxHeight={60}
      background={theme.colors.white}
      borderBottom={`1px solid ${theme.colors.grey03}`}
      zIndex={10}
      position={"fixed"}
      paddingLeft={paddigLeft + 30}
      paddingRight={30}
      style={{
        transition: "all 0.3s",
      }}
    >
      <Box justifyContent="space-between" display={"flex"} height={"100%"}>
        <Box display={"flex"}>
          {isTabletOrMobile ? (
            <Stack display={"flex"} flexDirection={"row"} alignItems={"center"}>
              <IconButton
                onClick={() => openDrawer()}
                style={{
                  borderRadius: "50%",
                  backgroundColor: `${theme.colors.grey02}`,
                  borderColor: `${theme.colors.grey04}`,
                }}
                type={"button"}
              >
                <IconDragHorizontal fill={"currentColor"} />
              </IconButton>
            </Stack>
          ) : (
            <></>
          )}
        </Box>
        <Box display={"flex"}>
          <Stack display={"flex"} flexDirection={"row"} alignItems={"center"}>
            <Avatar
              backgroundColor={"greylight03"}
              color={"greymed04"}
              icon={IconFlowerGrid}
              name={"Workspace"}
            />
            <Stack>
              <Heading as={"span"} scale={200} color={"greydark02"}>
                Kata.ai
              </Heading>
            </Stack>
          </Stack>
        </Box>
        <Box display={"flex"}>
          <Stack display={"flex"} flexDirection={"row"} alignItems={"center"}>
            <AvatarMenu />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Navbar;
